















import { Component, Watch } from 'vue-property-decorator';
import FormFooter from '@/components/FormFooter.vue';
import FormBase from '@/mixins/FormBase';
import { Action } from 'vuex-class';
import VehicleAction from '@/core/interfaces/VehicleAction';

@Component({
    components: { FormFooter },
})
export default class VehicleActionForm extends FormBase<VehicleAction> {
    @Action('saveVehicleAction')
    saveAction!: (barn: Partial<VehicleAction>) => Promise<VehicleAction>;

    name = '';

    @Watch('initial', { immediate: true })
    setFromInitial(): void {
        if (!this.initial) {
            return;
        }

        this.name = this.initial.name || '';
    }

    get parseForm(): Partial<VehicleAction> {
        return {
            ...this.initial,
            id: this.initial?.id || undefined,
            name: this.name,
        };
    }
}

